//2026-05-04T19:00:00Z -> 4 мая 2026 г.
export const formatDateForEvent = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

//2026-05-04T19:00:00Z -> 4 мая 22:00
export const formatDateForQRCheck = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "long",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};
//date/new Date() -> 2026-04-29T12:17:33.120+04:00
export const getLocalIsoString = (date = new Date()) => {
  const offset = date.getTimezoneOffset();
  const localTime = new Date(date.getTime() - offset * 60000);
  const sign = offset > 0 ? "-" : "+";
  const abs = Math.abs(offset);
  const pad = (n) => String(n).padStart(2, "0");

  return `${localTime.toISOString().slice(0, -1)}${sign}${pad(
    Math.floor(abs / 60),
  )}:${pad(abs % 60)}`;
};
